/**
 * The 2D plan's load callback (`store.state.load2dViewerCallback`, set by the store's `zoomToPointIn2D`)
 * runs once the plan's document has loaded. It may highlight tags through the labels extension
 * (platform/viewer views.js `highlightTagsIn2d`), and APS's getExtension answers null until that
 * extension's load settles, so the callback waits for it. A failed load is reported and the callback
 * still runs (the highlight then says the tag is not shown). A plan viewer replaced meanwhile leaves
 * the callback to the new plan's load.
 *
 * No imports on purpose: this file is unit-tested under plain Node.
 */

/** The plan viewer extensions the load callback may use. */
export const PLAN_CALLBACK_EXTENSIONS = Object.freeze(['labels3dExt']);

/**
 * Starts loading PLAN_CALLBACK_EXTENSIONS on `planViewer`, then runs and clears the pending callback.
 * @param {{ state: object, commit: Function }} store the app store
 * @param {object} planViewer the plan viewer whose document just loaded
 * @param {(err: Error) => void} onError told when an extension fails to load
 * @returns {Promise<void>}
 */
export async function runPlanLoadCallback(store, planViewer, onError) {
  const loading = PLAN_CALLBACK_EXTENSIONS.map((id) => planViewer.loadExtension(id));
  try {
    await Promise.all(loading);
  } catch (err) {
    onError(err);
  }
  if (store.state.planViewer !== planViewer) return;

  const callback = store.state.load2dViewerCallback;
  if (callback) {
    callback();
    store.commit('setLoad2dViewerCallback', null);
  }
}
